import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActionSheetController, IonInfiniteScroll, NavController } from '@ionic/angular';
import { ActionSheetButton } from '@ionic/core';
import { SearchService } from 'src/app/services/search/search.service';


@Component({
  selector: 'app-search',
  templateUrl: './search.page.html',
  styleUrls: ['./search.page.scss'],
})
export class SearchPage {
  query: string;
  page: number;
  storeList: any[] = [];
  actionSheetButtonList: ActionSheetButton[] = [];
  location = 'Across Airport';
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  noData: number;


  constructor(private searchService: SearchService, private activatedRoute: ActivatedRoute, private actionSheetController: ActionSheetController, private navControl: NavController) {
  }

  ionViewDidEnter() {
    this.initPageState();
    this.searchService.initApiParams();
    this.query = this.activatedRoute.snapshot.queryParamMap.get('q');
    this.searchService.searchForStore(this.query, this.page).subscribe((response) => {
      this.updateFoodPageState(response.retailers, response);
    });
  }

  getNextPage(event) {
    let totalStoreCount: number;
    this.page++;
    this.searchService.searchForStore(this.query, this.page).subscribe(response => {
      this.updateFoodPageState(this.storeList.concat(response.retailers), response);
      totalStoreCount = response.totalCount;
      event.target.complete();
      if (this.storeList.length === totalStoreCount) {
        event.target.disabled = true;
      } else {
        event.target.disabled = false;
      }
    });
  }

  private updateFoodPageState(storeListData: any[] | null, responseObj: any) {
    if (!storeListData || storeListData.length === 0) {
      this.noData = 1;
      return;
    }
    if (storeListData && storeListData.length < this.searchService.apiParams.perpage) {
      if (this.infiniteScroll && !this.infiniteScroll.disabled) {
        this.infiniteScroll.disabled = true;
      }
    }
    this.storeList = storeListData;
    this.actionSheetButtonList = [];
    if (responseObj.locations && responseObj.locations.length > 0) {
      responseObj.locations.sort().forEach(element => {
        const obj = {
          text: element,
          role: '',
          handler: () => {
            this.filterDataByLocation(element);
          }
        };
        if (this.location === element) {
          obj.role = 'selected';
        }
        let actionSheetButton: ActionSheetButton;
        actionSheetButton = obj;
        this.actionSheetButtonList.push(actionSheetButton);
      });
    }
  }
  initPageState() {
    this.noData = 0;
    this.page = 1;
    this.storeList = null;
  }
  private filterDataByLocation(location: string) {
    this.initPageState();
    if (this.location !== location) {
      this.location = location;
      if (this.infiniteScroll && this.infiniteScroll.disabled) {
        this.infiniteScroll.disabled = false;
      }
      this.searchService.filterDataByLocation(location, this.page).subscribe(response => {
        this.updateFoodPageState(response.retailers, response);
      });
    }
  }
  async openLocationSheet() {
    const actionSheetButton: ActionSheetButton = {
      text: 'Close',
      role: 'cancel',
      handler: () => {
      }
    };
    this.actionSheetButtonList.push(actionSheetButton);
    const actionSheet = await this.actionSheetController.create({
      header: 'Filter By Location',
      // mode: 'ios',
      buttons: this.actionSheetButtonList
    });
    await actionSheet.present();
  }
  navgateBack() {
    this.navControl.navigateBack('/shopping');
    // this.locationSrvc.back();
  }
  filterData(event) {

    if (event.key === 'Enter') {
      this.initPageState();
      this.searchService.searchForStore(this.query, this.page).subscribe((response) => {
        this.updateFoodPageState(response.retailers, response);
      });
    }
  }
}
